import {Component, Vue} from "vue-property-decorator";
import PazToast from "@pazion/pazion-core/src/components/utils/PazToast.vue";

@Component
export default class BaseMixin extends Vue {

    readonly $applicationVersion!: string;// = 'v123';
    readonly $productionTip!: boolean;// = false;
    readonly $orderListingType!: string;// = "order";
    readonly $measureCalculationUnit!: string;// = "mm";
    readonly $orderAutoReference!: boolean;// = false;
    readonly $loginAsUser!: boolean;// = false;
    readonly $userfieldSalutation!: boolean;// = false;
    readonly $userfieldFirstName!: boolean;// = false;
    readonly $defaultCountryId!: boolean;// = 150;
    readonly $enforceTwoFactor!: boolean;// = false;
    readonly $ediApiManagement!: boolean;// = false;
    readonly $copyOrder!: boolean;// = false;
    readonly $editOrder!: boolean;// = false;
    readonly $orderManagement!: boolean;// = false;
    readonly $orderDetails!: boolean;// = false;
    readonly $createDelivery!: boolean;// = false;
    readonly $showDeliveryDialog!: boolean;// = false;
    readonly $editOrderLineStatus!: boolean;// = false;
    readonly $stockManagement!: boolean;// = false;
    readonly $productManagement!: boolean;// = false;
    readonly $productionManagement!: boolean;// = false;
    readonly $dossierManagement!: boolean;// = false;
    readonly $orderDossierManagement!: boolean;// = false;
    readonly $accountManagement!: boolean;// = false;
    readonly $orderlineMeasureCalculation!: boolean;// = false;
    readonly $orderQuickMenu!: boolean;// = false;
    readonly $offerManagement!: boolean;// = false;
    readonly $repriceManagement!: boolean;// = false;
    readonly $returnManagement!: boolean;// = false;
    readonly $invoiceManagement!: boolean;// = false;
    readonly $contractManagement!: boolean;// = false;
    readonly $transactionManagement!: boolean;// = false;
    readonly $pricelistManagement!: boolean;// = false;
    readonly $logManagement!: boolean;// = false;
    readonly $queueManagement!: boolean;// = false;
    readonly $membersCardManagement!: boolean;// = false;
    readonly $groupManagement!: boolean;// = false;
    readonly $requiredDocumentManagement!: boolean;// = false;
    readonly $fulfilmentManagement!: boolean;// = false;
    readonly $invoicePaymentManagement!: boolean;// = false;
    readonly $onlyShowCompany!: boolean;// = false;
    readonly $amazonSettings!: boolean;// = false;
    readonly $boldotcomSettings!: boolean;// = false;
    readonly $bumbalSettings!: boolean;// = false;
    readonly $dynamicsSettings!: boolean;// = false;
    readonly $exactonlineSettings!: boolean;// = false;
    readonly $opencartSettings!: boolean;// = false;
    readonly $postnlSettings!: boolean;// = false;
    readonly $shopwareSettings!: boolean;// = false;
    readonly $woocommerceSettings!: boolean;// = false;
    readonly $devPackage!: boolean;// = false;
    readonly $packageSettings!: boolean;// = false;

    get isDevelopment(): boolean {
        return process.env.NODE_ENV === 'development';
    }

    showDefaultServerErrorToast(fromContext?: boolean) {
        let instance = null;
        if (this.$refs.toast instanceof PazToast) {
            instance = this.$refs.toast;
        } else if (this.$parent.$refs.toast instanceof PazToast) {
            instance = this.$parent.$refs.toast;
        }
        if (!(instance instanceof PazToast)) {
            return;
        }

        instance.show({
            message: 'An error occurred, please contact the administrator',
            icon: 'mdi-close-circle',
            color: 'red'
        });
    }

}
